import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const SocialProofTicker = () => {
  const [current, setCurrent] = useState(null);
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const initialDelay = setTimeout(() => { showNext(); }, 12000);
    return () => clearTimeout(initialDelay);
  }, []);

  const showNext = () => {
    const messages = t('socialProof.messages', { returnObjects: true });
    const randomIdx = Math.floor(Math.random() * messages.length);
    setCurrent(messages[randomIdx]);
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
      const nextDelay = 15000 + Math.random() * 10000;
      setTimeout(showNext, nextDelay);
    }, 4000);
  };

  return (
    <AnimatePresence>
      {visible && current && (
        <motion.div
          initial={{ opacity: 0, x: -100, y: 20 }}
          animate={{ opacity: 1, x: 0, y: 0 }}
          exit={{ opacity: 0, x: -100 }}
          transition={{ type: 'spring', damping: 20, stiffness: 300 }}
          className="fixed bottom-20 left-4 z-40 max-w-xs"
          data-testid="social-proof-ticker"
        >
          <div className="bg-[#151515] border border-white/10 rounded-xl px-4 py-3 shadow-2xl shadow-black/50">
            <div className="flex items-center gap-3">
              <div className="w-2.5 h-2.5 rounded-full bg-[#c8ff00] animate-pulse flex-shrink-0" />
              <p className="text-sm text-gray-300">
                <span className="text-white font-semibold">{current.business}</span> in {current.city}{' '}
                <span className="text-[#c8ff00] font-medium">{current.action}</span>
              </p>
            </div>
            <p className="text-gray-500 text-xs mt-1 ml-[22px]">
              {Math.floor(Math.random() * 8) + 1} {t('socialProof.minutesAgo')}
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SocialProofTicker;
